export const UNIT_SIZE_DECREASE_WITHOUT_SUPPLY = -2;

export const UNIT_SIZE_FOR_SUPPLY_ON_OTHER = 1;
export const UNIT_SIZE_FOR_SUPPLY_ON_BARRACKS = 2;
export const UNIT_SIZE_FOR_SUPPLY_WITH_MILITARY_CAMP = 4;

export const UNIT_D4_SIZE_FOR_SUPPLY_ON_OTHER = 0;
export const UNIT_D4_SIZE_FOR_SUPPLY_ON_BARRACKS = 1;
export const UNIT_D4_SIZE_FOR_SUPPLY_WITH_MILITARY_CAMP = 2;

export const UNIT_ID_PREFIX = 'unit_';

export const UNIT_D4_MAX_SHOOTING_RANGE = 5;